import { useTranslation, type I18nKey } from '@pos/i18n';
import { StatusTag } from '../components/StatusTag';

type StatusKind = 'ticket' | 'print' | 'job' | 'printer';

/** One tag for every kitchen status (ticket, print, job, printer); colours come from the shared StatusTag map. */
export function KitchenStatusTag({ kind, status }: { kind: StatusKind; status: string }) {
  const { t } = useTranslation();
  return (
    <StatusTag status={status}>
      {t(`admin.kitchen.${kind}.${status}` as I18nKey, { defaultValue: status })}
    </StatusTag>
  );
}
